
<div class="viewer-backdrop" (click)="onBackdropClick($event)" (keydown.escape)="close()">
  <div class="viewer-modal">
    <!-- Header -->
    <header class="viewer-header">
      <button class="btn-back" (click)="close()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      @if (this.emailData.threadId && threadEmails().length > 1) {
      <button class="btn-thread" (click)="toggleThread()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        Thread ({{ threadEmails().length }})
      </button>
      }
    </header>

    <div class="viewer-body">
      @if(emailData && emailData.messageId && emailData.messageId!=""){
      <!-- Thread Panel -->
      @if (showThread() && threadEmails().length > 0) {
      <aside class="thread-panel">
        <app-aqa-thread [emails]="threadEmails()" [currentEmailId]="emailData.messageId" (threadClicked)="threadClicked($event)"/>
      </aside>
      }

      <!-- Email Content -->
      <main class="email-content">
        <!-- Subject -->
        <h1 class="email-subject">
          @if (highlights?.subject?.length) {
          <span [innerHTML]="highlights!.subject![0]"></span>
          } @else {
          {{ emailData.subject ?? emailData.metadata_subject ?? emailData.normalizedSubject ?? 'No subject' }}
          }
        </h1>

        <!-- Meta -->
        <div class="email-meta">
          <div class="meta-row">
            <span class="meta-label">From:</span>
            <span class="meta-value from">{{ emailData.metadata_message_from ?? 'Unknown' }}</span>
          </div>
          @if (emailData.toRecipients?.length || emailData.to) {
          <div class="meta-row">
            <span class="meta-label">To:</span>
            <span class="meta-value">{{ emailData.toRecipients?.join(', ') ?? emailData.to }}</span>
          </div>
          }
          @if (emailData.ccRecipients?.length || emailData.cc) {
          <div class="meta-row">
            <span class="meta-label">CC:</span>
            <span class="meta-value">{{ emailData.ccRecipients?.join(', ') ?? emailData.cc }}</span>
          </div>
          }
          <div class="meta-row">
            <span class="meta-label">Date:</span>
            <span class="meta-value">{{ formatDateTime(emailData.metadata_creation_date) }}</span>
          </div>
        </div>

        <!-- Attachments -->
        @if (emailData.hasAttachments && emailData.attachmentCount && emailData.attachmentCount>0) {
        <div class="attachments-section">
          <h3>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
            </svg>
            Attachments ({{ emailData.attachmentCount }})
          </h3>
          <ul class="attachments-list">
            @for (att of emailData.attachmentNames; track att) {
            <li class="attachment-item" (click)="attachmentClicked(att)">
              <span class="att-icon">{{ getIcon(getExtension(att)) }}</span>
              <div class="att-info">
                <span class="att-name">{{ att }}</span>
              </div>
            </li>
            }
          </ul>
        </div>
        }

        <!-- Highlights -->
        @if (highlights?.content?.length || highlights?.attachment?.length) {
        <div class="highlights-section">
          <h3>Search Matches</h3>
          <ul class="highlights-list">
            @for (hl of highlights?.content ?? []; track $index) {
            <li><span class="hl-label">Body:</span> <span [innerHTML]="hl"></span></li>
            }
            @for (hl of highlights?.attachment ?? []; track $index) {
            <li><span class="hl-label">Attachment:</span> <span [innerHTML]="hl"></span></li>
            }
          </ul>
        </div>
        }

        <!-- Body -->
        <div class="body-section">
          <h3>Message</h3>
          @if (emailData.message_text) {
          <div class="body-content" [innerHTML]="safeHtml">
          </div>
          } @else {
          <div class="body-content">
            <p class="no-content">No content available</p>
          </div>
          }
        </div>

        <!-- Attachment Content -->
        @if (emailData.attachmentContent) {
        <div class="attachment-content-section">
          <h3>Attachment Content</h3>
          <div class="attachment-content">
            <pre>{{ emailData.attachmentContent }}</pre>
          </div>
        </div>
        }
      </main>
      }
    </div>
  </div>
</div>


<app-loading-indicator [isLoading]="loading"
                       [loadingMessage]="loadingMessage">

</app-loading-indicator>
